import styled from 'styled-components';

export const CheckList = styled.div`

  margin-top: 10px;
  background-color: #ffffff;
  border: 1px solid #ccc;
  width: 600px;
  padding: 12px;
  margin-bottom:20px;

  @media (max-width: 992px) {
    width:100%;

    input {
      width: auto;
    }
  }

  ul {
    margin: 0;
    padding: 0;
  }

  ul li {
    display: flex;
    align-item: center;
  }

  input {
    margin-right:5px;
    margin-bottom:15px;
  }

  label {
    margin-top:1px;
  }

`;



// WEBPACK FOOTER //
// ./src/components/forms/WorkEnquiryForm.style.js